<ng-container *ngIf="mostrarLandingPage">
  <!-- Contenedor Landing Page -->
  <div class="grid grid-cols-1 scroll-smooth">
    <!-- Contenedor Video -->
    <div class="relative w-full min-h-screen">
      <video #videoPlayer class="w-full h-full object-cover brightness-50" loop playsinline>
        <source src="../../assets/videos/ht_video.mp4" type="video/mp4">
      </video>
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="animacionVideo">
          <span class="texto1">{{ 'esto-es' | translate }} </span>
          <span class="texto2">HT SPORTS</span>
        </div>
      </div>
    </div>
    <!-- Contenedor Carrusel -->
    <div class="p-5" [appObserveVisibility]="false">
      <div class="m-5 flex items-center justify-center">
        <h1 class="text-3xl font-extrabold px-4 text-azul whitespace-nowrap ">{{'titulo-Carrusel' | translate}}</h1>
        <hr class="w-full border-azul">
      </div>
      <div class="w-full h-[300px] md:h-[400px] lg:h-[500px]">
        <nz-carousel nzAutoPlay [nzEffect]="'scrollx'" [nzLoop]="true" class="w-full h-full" [nzDots]="false">
          <!-- Carrusel Esp -->
          <ng-container *ngIf="this.translate.currentLang == 'es'">
            <div nz-carousel-content *ngFor="let imagen of imgCarruselEsp" class="w-full h-full flex justify-center items-center">
              <img [src]="imagen" [alt]="imagen" class="w-full h-full object-contain">
            </div>
          </ng-container>
          <!-- Carrusel Eng -->
          <ng-container *ngIf="this.translate.currentLang == 'gb'">
            <div nz-carousel-content *ngFor="let imagen of imgCarruselEng" class="w-full h-full flex justify-center items-center">
              <img [src]="imagen" [alt]="imagen" class="w-full h-full object-contain">
            </div>
          </ng-container>
        </nz-carousel>
      </div>
    </div>
    <!-- Contenedor Cards -->
    <div [appObserveVisibility]="true">
      <div class="flex flex-col md:flex-row items-center gap-2 w-full px-4">
        <hr class="flex-1 border-azul hidden md:block">
        <h1 class="text-xl sm:text-2xl md:text-3xl font-extrabold text-azul text-center md:text-left">{{ 'titulo-Cards' | translate }}</h1>
        <hr class="flex-1 border-azul hidden md:block">
      </div>
      <hr class="w-full border-azul md:hidden">
      <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-5">
        <!-- Card Info Aficionado -->
        <div>
          <div class="border-solid border-2 border-opacity-25 rounded-2xl p-5 grid grid-rows-[auto_1fr_auto_auto] gap-5 transition duration-300 ease-in-out hover:-translate-y-1">
            <div class="overflow-hidden">
              <img class="transition-transform duration-1000 ease-in-out hover:scale-125 rounded" src="https://killerasturias.com/drimage/920/0/2500/-/sites/default/files/2022-02/51693656604_d3e898d0e4_k%20%282%29.jpg" alt="Imagen aficionado">
            </div>
            <h1 class="text-center text-3xl font-extrabold tracking-tight">{{'titulo-Aficionado-Exp' | translate}}</h1>
            <button class="p-2 bg-azul text-white w-full rounded transition ease-in-out hover:-translate-y-1 hover:text-blue-300 duration-1000" (click)="funcMostrarInfoAficionado()">{{'btn-Mas-Informacion' | translate}}</button>
            <div *ngIf="mostrarInfoAficionado" @fadeInOut>
              <h1 class="text-2xl text-center font-bold italic text-azul">"{{'titulo-Azul-Exp-Aficionado' | translate}}"</h1>
              <p class="text-center">{{'texto-Exp-Aficionado' | translate}}</p>
            </div>
          </div>
        </div>
        <!-- Card Info Jugador -->
        <div>
          <div class="border-solid border-2 border-opacity-25 rounded-2xl p-5 grid grid-rows-[auto_1fr_auto_auto] gap-5 transition duration-300 ease-in-out hover:-translate-y-1">
            <div class="overflow-hidden">
              <img class="transition-transform duration-1000 ease-in-out hover:scale-125 rounded" src="https://statics-maker.llt-services.com/leg/images/2025/02/15/xlarge-wp/f7e1dad0-542c-4c2c-a830-78367ba4b6db-346.webp" alt="Imagen Jugador">
            </div>
            <h1 class="text-center text-3xl font-extrabold tracking-tight">{{'titulo-Deportista-Exp' | translate}}</h1>
            <button class="p-2 bg-azul text-white w-full rounded transition ease-in-out hover:-translate-y-1 hover:text-blue-300 duration-1000" (click)="funcMostrarInfoJugador()">{{'btn-Mas-Informacion' | translate}}</button>
            <div *ngIf="mostrarInfoJugador" @fadeInOut>
              <h1 class="text-2xl text-center font-bold italic text-azul">"{{'titulo-Azul-Exp-Deportista' | translate}}"</h1>
              <p class="text-center">{{'texto-Exp-Deportista' | translate}}</p>
            </div>
          </div>
        </div>
        <!-- Card Info Cuerpo Tecnico -->
        <div class="md:col-span-2 lg:col-span-1">
          <div class="border-solid border-2 border-opacity-25 rounded-2xl p-5 grid grid-rows-[auto_1fr_auto_auto] gap-5 transition duration-300 ease-in-out hover:-translate-y-1">
            <div class="overflow-hidden">
              <img class="transition-transform duration-1000 ease-in-out hover:scale-125 rounded" src="https://cdn.vox-cdn.com/thumbor/V-lWecKTEUTO9AcFNT7Lz6I6sB8=/0x0:2049x1366/1220x813/filters:focal(766x105:1092x431):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/72532265/1595868752.0.jpg" alt="Imagen Entrenador">
            </div>
            <h1 class="text-center text-3xl font-extrabold tracking-tight">{{'titulo-Entrenador-Exp' | translate}}</h1>
            <button class="p-2 bg-azul text-white w-full rounded transition ease-in-out hover:-translate-y-1 hover:text-blue-300 duration-1000" (click)="funMostrarInfoCT()">{{'btn-Mas-Informacion' | translate}}</button>
            <div *ngIf="mostrarInfoCT" @fadeInOut>
              <h1 class="text-2xl text-center font-bold italic text-azul">"{{'titulo-Azul-Exp-Entrenador' | translate}}"</h1>
              <p class="text-center">{{'texto-Exp-Entrenador' | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <br>
</ng-container>



